import Marketplace from '@/views/marketPlace/MarketPlaceWrapper.vue'

const routes = {
    path: '/:account_id/marketplace',
    name: 'MarketPlaceWrapper',
    component: Marketplace
}

export default routes
